import {
    getLang,
    getLangFromUrl,
    getLangFromNavigator,
    getLangFromUa
} from './libs/lang';
let curLang
const defaultOption = {
    key: 'lang',
    defaultLang: 'en',
    keyMap: {
        // 台湾也和繁体中文一样处理
        'zh-tw': () => 'zh-hk',
        // 内地也和繁体中文一样处理
        'zh-cn': () => 'zh-hk'
    }
}

function setLangOption(option = {}) {
    Object.assign(defaultOption, option);
}

function _getLang(selectArr, option = {}) {
    if (curLang) return curLang;
    const finalOption = Object.assign({}, defaultOption, option);
    const lang = getLang(selectArr, finalOption);
    curLang = lang;
    return curLang;
}

function getLanguage() {
    return _getLang(['zh-cn', 'zh-hk', 'en'], {
        key: 'lang',
        defaultLang: 'en',
        keyMap: {
            // 台湾也和繁体中文一样处理
            'zh-tw': () => 'zh-hk',
        }
    })
}

function isEn() {
    return getLanguage() === 'en'
}

function setLanguage(lang) {
    curLang = lang;
}

export {
    _getLang as getLang,
    getLangFromUrl,
    getLangFromNavigator,
    getLangFromUa,
    setLangOption,
    getLanguage,
    setLanguage,
    isEn
}
